// @flow

import React from 'react';
import { withRouter } from 'react-router-dom';

type Props = {}

type State = {}


class AreaData extends React.Component<Props, State> {
  state = {};

  render() {
    return (
      <div>
       This page is not available yet...
      </div>
    );
  }
}

export default withRouter(AreaData);
